export default __webpack_public_path__ + "static/media/peraTtsIt_It60.281787be.mp3";